<app-loader [isLoader]="loading"></app-loader>
<section class="page-gutter">
    <div class="portlet-container">
        <div class="portlet-head">
            <div class="title-block">
                <h2>User Listing</h2>
                <p>Manage users, access roles, and account status</p>
            </div>
            <div class="action toolbar-actions">
                <div class="search-box margin">
                    <img [src]="searchIcon" />
                    <input class="form-control" type="text" placeholder="Search by Email,Name"
                        [(ngModel)]="filter.search" (input)="onSearch($event)" />
                </div>
                <button class="btn default fw-semi margin" (click)="openFilter()">
                    <img [src]="filterIcon" class="filter-icon" alt="filter">
                    Filters
                </button>

                @if(userPermissions.includes(1)){
                <button class="btn primary margin" (click)="openCreateUserModal()">
                    <img [src]="plusIcon" class="plus-icon" alt="plus">
                    Create New
                </button>
                }
            </div>
        </div>
        <div class="portlet-body">
            <div class="filter-gutter" [ngClass]="{'opened': toggleFilter}">
                <app-filter-shared-dropdown [title]="'Name'" [items]="nameList" [selectedItems]="filter.name"
                    (clearAll)="clearFilterDropdown('name')" (selectAllChange)="selectFilterDrowDownItem($event,'name')"
                    (itemChecked)="isItemChecked($event,'name')"></app-filter-shared-dropdown>
                <app-filter-shared-dropdown [title]="'Role'" [items]="roleList" [selectedItems]="filter.role"
                    (clearAll)="clearFilterDropdown('role')" (selectAllChange)="selectFilterDrowDownItem($event,'role')"
                    (itemChecked)="isItemChecked($event,'role')"></app-filter-shared-dropdown>
                <button class="no-btn clear" (click)="clearFilter()">Clear all</button>
            </div>

            @if(userList.length > 0){
            <div class="table-container" [ngClass]="{'active-filter': !toggleFilter}">
                <table class="table primary-table">
                    <thead>
                        <tr>
                            <th class="sorting">
                                <span class="sortable" (click)="sorting('name')">
                                    <span class="label">Name</span>
                                    <div class="sort-arrows">
                                        <div class="sort-arrow up"
                                            [class.active]="sortingKey === 'name' && sortingValue === 'ASC'">
                                        </div>
                                        <div class="sort-arrow down"
                                            [class.active]="sortingKey === 'name' && sortingValue === 'DESC'">
                                        </div>
                                    </div>
                                </span>
                            </th>
                            <th>
                                Email

                            </th>
                            <th>
                                Role
                            </th>
                            <th class="col-center">Status</th>
                            <th class="sorting">
                                <span class="sortable" (click)="sorting('created_at')">
                                    <span class="label">Created At</span>
                                    <div class="sort-arrows">
                                        <div class="sort-arrow up"
                                            [class.active]="sortingKey === 'created_at' && sortingValue === 'ASC'">
                                        </div>
                                        <div class="sort-arrow down"
                                            [class.active]="sortingKey === 'created_at' && sortingValue === 'DESC'">
                                        </div>
                                    </div>
                                </span>
                            </th>
                            <th class="action-header">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for(user of userList; track $index){
                        <tr>
                            <td>{{user.name || '-'}}</td>
                            <td>{{user.email || '-'}}</td>
                            <td>
                                {{(user.role | upperCase) || '-'}}
                            </td>
                            <td class="col-center">
                                <label class="switch-bar" [ngClass]="{'disabled': !userPermissions.includes(4)}">
                                    <input type="checkbox"
                                        [checked]="user.tempStatus ?? user.status === 'active' ? true : false"
                                        (change)="onToggleStatus(user, $event)" />
                                    <span class="switch-slider"></span>
                                </label>
                            </td>
                            <td>{{user.created_at | date}}</td>
                            <td>
                                <div class="td-action">
                                    <button class="action-btn edit-btn" (click)="openEditUserModal(user.id)"
                                        [disabled]="!userPermissions.includes(2)" title="Edit User">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round">
                                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                                            <path d="m18.5 2.5 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                                        </svg>
                                    </button>
                                    <button class="action-btn delete-btn" (click)="openDeleteModal(user)"
                                        [disabled]="!userPermissions.includes(3)" title="Delete User">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round">
                                            <polyline points="3,6 5,6 21,6"></polyline>
                                            <path
                                                d="m19,6v14a2,2 0 0,1 -2,2H7a2,2 0 0,1 -2,-2V6m3,0V4a2,2 0 0,1 2,-2h4a2,2 0 0,1 2,2v2">
                                            </path>
                                            <line x1="10" y1="11" x2="10" y2="17"></line>
                                            <line x1="14" y1="11" x2="14" y2="17"></line>
                                        </svg>
                                    </button>
                                </div>
                            </td>
                        </tr>
                        }
                    </tbody>
                </table>
            </div>
            }

            @if(userList.length > 0){
            <app-custom-pagination [filter]="filter" [total]="totalCount" (savePage)="fetchUserDataByPage($event)"></app-custom-pagination>
            }
            @if(userList.length == 0 && loading == false){
            <app-no-data [noData]="noData" (createNewClick)="openCreateUserModal()"></app-no-data>
            }
        </div>
    </div>
</section>

<app-shared-modal [modalConfig]="modalConfig" (confirm)="onModalConfirm()" (cancel)="onModalCancel()">
</app-shared-modal>
<app-create-user (close)="closeUserModal()" (reload)="reloadUserList()"></app-create-user>